import { PropsWithChildren } from "react";
import { useBannerState } from "shared/hooks";
import { StepsContentStyles } from "./StepsContent.styles";

export const StepsContent = ({ children }: PropsWithChildren) => {
  const { bannerHeight } = useBannerState();

  return <StepsContentStyles topOffset={bannerHeight}>{children}</StepsContentStyles>;
};
